export default __webpack_public_path__ + "static/media/Compassível.7058eaa1.svg";